<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock
        title="Accès à votre demande d'agrément"
        v-if="dossier == null"
      >
        <v-row>
          <v-col cols="4">
            Merci de saisir le code d'accès qui vous a été communiqué par
            courriel :
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="5">
            <v-text-field
              v-model="codeAcces"
              :append-icon="showCode ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required]"
              :type="showCode ? 'text' : 'password'"
              name="input-10-1"
              label="code d'accès"
              counter
              @click:append="showCode = !showCode"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-btn color="blue" class="mr-4 white--text" @click="setCode"
              >Envoyer</v-btn
            >
          </v-col>
        </v-row>
      </BaseBlock>
      <div v-else>
        <Parties v-if="dossier.etat.id == 1" />
        <p v-else>
          <b
            >Votre dossier a été transmis et est en cours d'examen, il n'est
            plus modifiable.</b
          >
          <br />
          Pour toute demande d'aide ou d'information, vous pouvez contacter le
          service Scolarité de l'UFR de Pharmacie {{ getUniv() }} via ce
          courriel :
          <b>{{ mailScolarite() }}</b>
          <br />
          <br />
          Vous pouvez néanmoins télécharger votre dossier en
          <a :href="linkToPDF(dossier)">cliquant ici</a>.
        </p>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import common from "@/common";
import BaseBlock from "@/components/base/BaseBlock";
import Parties from "@/components/formulaire/Parties";
import ApiDossierRepository from "@/repositories/ApiDossierRepository";

export default {
  name: "Formulaire",
  components: { BaseBlock, Parties },
  data: () => ({
    rules: {
      required: value => !!value || "Ce code est requis."
    },
    showCode: false,
    codeAcces: ""
  }),
  computed: {
    ...mapState(["dossier"])
  },
  methods: {
    isDossierUnivLille() {
      return (
        this.dossier.officine.codePostal.indexOf("59") == 0 ||
        this.dossier.officine.codePostal.indexOf("62") == 0
      );
    },
    mailScolarite() {
      if (this.isDossierUnivLille()) {
        return process.env.VUE_APP_SCOL_MAIL_LILLE;
      } else {
        return process.env.VUE_APP_SCOL_MAIL_AMIENS;
      }
    },
    getUniv() {
      if (this.isDossierUnivLille()) {
        return "de l'Université de Lille";
      } else {
        return "de l'Université Jules Verne d'Amiens";
      }
    },
    async setCode() {
      await this.$store.dispatch("setDossier", null);
      this.$cookies.remove("pharmagrement-user");
      try {
        const dossier = await ApiDossierRepository.get(
          this.$route.params.iddossier,
          this.codeAcces
        );
        await this.$store.dispatch("setDossier", dossier);
        let user = {
          displayName: dossier.contactPrenom + " " + dossier.contactNom,
          roles: ["ROLE_PHARMACIEN"]
        };
        await this.$store.dispatch("setNonConnectedUser", user);
        this.$cookies.set("pharmagrement-user", user);
      } catch (error) {
        this.$toast.error(
          "Votre demande ne peut aboutir. Merci de vérifier le code d'accès que vous avez saisi."
        );
      }
    },
    linkToPDF(dossier) {
      return common.getPDFURL(dossier, dossier.codeAcces);
    }
  }
};
</script>
